import React from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const categories = [
  { name: 'Casual', slug: 'casual', type: 'styles' },
  { name: 'Formal', slug: 'formal', type: 'styles' },
  { name: 'Street Style', slug: 'street-style', type: 'styles' },
  { name: 'Business', slug: 'business', type: 'styles' },
  { name: 'Wedding', slug: 'wedding', type: 'occasions' },
  { name: 'Date Night', slug: 'date-night', type: 'occasions' },
];

const PopularCategories: React.FC = () => (
  <Box sx={{ py: 4 }}>
    <Typography variant="h4" component="h2" sx={{ fontWeight: 700, mb: 3 }}>Browse by Style</Typography>
    <Grid container spacing={2}>
      {categories.map((cat) => (
        <Grid item xs={6} sm={4} md={2} key={cat.slug}>
          <Paper
            component={RouterLink}
            to={`/${cat.type}/${cat.slug}`}
            sx={{
              p: 2, textAlign: 'center', textDecoration: 'none', color: 'text.primary',
              '&:hover': { bgcolor: 'action.hover' }, cursor: 'pointer', height: '100%',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{cat.name}</Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default PopularCategories;
